(function ($) {
  var gridBreakpoints = {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1440
  };

  var mediaQueries = {
    xs: window.matchMedia('(max-width: ' + (gridBreakpoints.sm - 1) + 'px)'),
    sm: window.matchMedia('(min-width: ' + (gridBreakpoints.sm) + 'px) and (max-width: ' + (gridBreakpoints.md - 1) + 'px)'),
    md: window.matchMedia('(min-width: ' + (gridBreakpoints.md) + 'px) and (max-width: ' + (gridBreakpoints.lg - 1) + 'px)'),
    lg: window.matchMedia('(min-width: ' + (gridBreakpoints.lg) + 'px) and (max-width: ' + (gridBreakpoints.xl - 1) + 'px)'),
    xl: window.matchMedia('(min-width: ' + (gridBreakpoints.xl) + 'px)')
  };

  for (var key in mediaQueries) {// loop through queries
    // call handler function explicitly at run time
    mediaQueryResponse(mediaQueries[key]);
    // call handler function whenever the media query is triggered
    mediaQueries[key].addListener(mediaQueryResponse);
  }

  function mediaQueryResponse(mediaQuery) {
    if (mediaQuery.matches) {
      for (const key in mediaQueries) {
        if (mediaQuery.media !== mediaQueries[key].media) {
          continue;
        }

        // Store current value as $(document).data('grid')
        $(document).data('grid', {'breakpoint': key, 'mediaQuery': mediaQuery.media});
        // Trigger event for listeners
        $(document).trigger('swr:grid', {
            'breakpoint': key,
            'mediaQuery': mediaQuery.media
          }
        );
      }
    }
  }

  function getNow() {
    function convertUnixTimeStamp(UNIX_timestamp) {
      var newDate = new Date();
      newDate.setTime(UNIX_timestamp);
      return newDate;
    }

    var url = window.location.href;
    var previewDateRegexp = /_previewDate-(\d*)/;
    var match = url.match(previewDateRegexp);
    var previewDate;
    if (match != null) {
      previewDate = convertUnixTimeStamp(match[1]);
    }
    return previewDate === undefined ? new Date() : previewDate;
  }

  function svgIcon(iconName, label, className, symbol) {
    label = 'string' === typeof label ? label.trim() : '';
    className = 'undefined' !== typeof className ? className : '';
    symbol = 'undefined' !== typeof symbol ? symbol : 'images/swr/symbols.svg';

    var escapeAttributeValue = function (value) {
      return value
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    };

    var isLabelled = label.length > 0;
    var accessibilityAttributes = isLabelled
      ? 'aria-label="' + escapeAttributeValue(label) + '" role="presentation"'
      : 'aria-hidden="true"';

    return COMMON.Utils.template('' +
      '<svg class="icon-{iconClass} {additionalClass}" focusable="false" {accessibilityAttributes}>' +
      '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + getAssetBaseUrl() + '/assets/{symbol}#{iconClass}"></use>' +
      '</svg>', {
      iconClass: iconName,
      symbol: symbol,
      additionalClass: className,
      accessibilityAttributes: accessibilityAttributes
    });
  }

  //Quelle: https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-details-using-javascript
  function getOS() {
    var unknown = '-';
    var isTablet = false;
    var isSmartphone = false;

    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;

    // system
    var os = unknown;
    var osVersion = unknown;

    var isTouch = navigator.maxTouchPoints > 1;
    var isTabletSize = Math.min(window.screen.width, window.screen.height) >= 600;

    var clientStrings = [
      {s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/},
      {s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/},
      {s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/},
      {s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/},
      {s: 'Windows Vista', r: /Windows NT 6.0/},
      {s: 'Windows Server 2003', r: /Windows NT 5.2/},
      {s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/},
      {s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/},
      {s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/},
      {s: 'Windows 98', r: /(Windows 98|Win98)/},
      {s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/},
      {s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
      {s: 'Windows CE', r: /Windows CE/},
      {s: 'Windows 3.11', r: /Win16/},
      {s: 'Windows Phone', r: /Windows Phone/},
      {s: 'Android', r: /Android/},
      {s: 'Open BSD', r: /OpenBSD/},
      {s: 'Sun OS', r: /SunOS/},
      {s: 'Chrome OS', r: /CrOS/},
      {s: 'Linux', r: /(Linux|X11(?!.*CrOS))/},
      {s: 'iOS', r: /(iPhone|iPad|iPod)/},
      {s: 'Mac OS X', r: /Mac OS X/},
      {s: 'Mac OS', r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
      {s: 'QNX', r: /QNX/},
      {s: 'UNIX', r: /UNIX/},
      {s: 'BeOS', r: /BeOS/},
      {s: 'OS/2', r: /OS\/2/},
      {s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
    ];

    for (var id in clientStrings) {
      var cs = clientStrings[id];
      if (cs.r.test(nAgt)) {
        os = cs.s;
        break;
      }
    }

    var isIpadInDesktopMode = /Macintosh/i.test(navigator.userAgent) && isTouch;

    if (isIpadInDesktopMode) {
      os = 'iOS';
    }

    if (/Windows/.test(os)) {
      var matchWin = /Windows (.*)/.exec(os);
      if (matchWin) {
        osVersion = matchWin[1];
      }
      os = 'Windows';
    }

    switch (os) {
      case 'Mac OS':
      case 'Mac OS X':
      case 'Android':
        var match = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(nAgt);
        if (match) {
          osVersion = match[1];
        }
        break;

      case 'iOS':
        var matchIOS = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
        if (matchIOS) {
          osVersion = matchIOS[1] + '.' + matchIOS[2] + '.' + (matchIOS[3] | 0);
        }
        break;
    }

    //Prüfen ob das Gerät ein Tablet ist:
    var isTabletUserAgent = /(iPad|Tablet|PlayBook|Silk|(Android(?!.*Mobile))|(Windows(?!.*Phone)(?=.*Touch)))/.test(navigator.userAgent.toLowerCase());
    var isMobileUserAgent = /(iPhone|Android.*Mobile|Windows Phone)/.test(navigator.userAgent.toLowerCase());

    if(isTabletUserAgent || (isTouch && isTabletSize && !isMobileUserAgent) || isIpadInDesktopMode) {
      isTablet = true;
    }

    //Smartphone-Erkennung: mobil, aber kein Tablet
    if (!isTablet && (os === 'Android' || os === 'iOS' || os === 'Windows Phone')) {
      isSmartphone = true;
    }

    console.log(
      'Betriebssystem: ' + os + '\n' +
      'Version: ' + osVersion + '\n' +
      'Gerät ist iPad in Desktop-Modus: ' + isIpadInDesktopMode + '\n' +
      'User-Agent: ' + nAgt + '\n' +
      'Gerät ist Tablet: ' + isTablet + '\n' +
      'Gerät ist Smartphone: ' + isSmartphone
    );

    return {
      'os': os,
      'osVersion': osVersion,
      'isIpadInDesktopMode': isIpadInDesktopMode,
      'nAgt': nAgt,
      'isTablet': isTablet,
      'isSmartphone': isSmartphone
    };
  }

  function getAssetBaseUrl() {
    const location = window.location;

    let assetBaseURL = ('undefined' === typeof window.isFractal ? '' : '../..');
    if (location.host === 'localhost:8080') {
      assetBaseURL = '/cms';
    } else if (location.pathname.includes('jenkins')) {
      const baseUrl = location.origin + location.pathname;

      const array = baseUrl.split("/");
      array.pop();
      assetBaseURL = array.join("/") + "/" + assetBaseURL;
    }

    return assetBaseURL;
  }

  const isAppChannel = (-1 !== window.location.href.indexOf('~apphtml') || navigator.userAgent.match(/^.*\.app/gi) || (window.isFractal && 'apphtml' === $('body').attr('data-fractal-channel')));

  /**
   * @license
   *
   * The MIT License (MIT)
   *
   * Copyright (c) 2013 Rhys Brett-Bowen
   */
  function debounce(func, wait) {
    var timeout;
    var timestamp;
    var lastArgs;
    var lastThis;

    var run = function () {
      timeout = null;
      if(lastArgs) {
        func.apply(lastThis, lastArgs);
        lastArgs = lastThis = null;
      }
    };

    var later = function () {
      var last = Date.now() - timestamp;

      if (last < wait) {
        setTimeout(later, wait - last);
      } else {
        (window.requestIdleCallback || run)(run);
      }
    };

    return function () {
      timestamp = Date.now();
      lastArgs = arguments;
      lastThis = this;

      if (!timeout) {
        timeout = setTimeout(later, wait);
      }
    };
  }

  /**
   * Utils
   */
  SWRNEU.Util = {
    getNow: getNow,
    svgIcon: svgIcon,
    getOS: getOS,
    getAssetBaseUrl: getAssetBaseUrl,
    isAppChannel: isAppChannel,
    debounce: debounce
  };
})(window.jQuery);
